import { fetchPermissions } from "./userPermissions";
import { ensureVisitorReferenceCache } from "./visitorReferenceCache";
import { prefetchVisitorRoutes } from "./visitorRoutePrefetch";

// Reference lists (categories, warehouses) are not needed to show the shop list,
// so they are loaded after a short delay instead of competing with it on startup.
// Screens that need them call ensureVisitorReferenceCache themselves and get the same cache/in-flight request.
const REFERENCE_DELAY_MS = 2000;

let bootstrapPromise = null;

export const runVisitorBootstrap = (axios, baseUrl, { force = false } = {}) => {
  if (!force && bootstrapPromise) {
    return bootstrapPromise;
  }

  bootstrapPromise = fetchPermissions(axios, baseUrl)
    .catch(() => null)
    .finally(() => {
      prefetchVisitorRoutes();
    });

  setTimeout(() => {
    ensureVisitorReferenceCache(axios, baseUrl).catch(() => null);
  }, REFERENCE_DELAY_MS);

  return bootstrapPromise;
};
